// The default value of ephemeralId to indicate the message
// refers to a non-ephemeral environment. Due to limitations of mysql and HAPI,
// the non-ephemeral environments must have a non-null and non-zero length value
// so we chose '-'
export const EPHEMERAL_ID_DEFAULT = '-';
